import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Menu from '@material-ui/core/Menu';
import MenuItemMUI from '@material-ui/core/MenuItem';
import Button from '../../../components/button';
import EmptyState from '../../../components/empty-state-container';

class SchemaMonitorResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
      menuOpenId: null,
    };
  }

  renderStatusChip = (status) => {
    const statusLower = status.toLowerCase();
    let chipClass = 'status-chip';
    
    if (statusLower === 'completed') {
      chipClass += ' chip-green';
    } else if (statusLower === 'failed' || statusLower === 'error') {
      chipClass += ' chip-red';
    } else if (statusLower === 'running' || statusLower === 'in_progress') {
      chipClass += ' chip-blue';
    } else {
      chipClass += ' chip-grey';
    }
    
    return (
      <Chip
        label={status}
        size="small"
        className={chipClass}
      />
    );
  };

  render() {
    const {
      selectedConfig,
      results,
      isLoadingResults,
      isRunning,
      onRunNow,
      onViewChanges
    } = this.props;

    if (!selectedConfig) {
      return null;
    }

    return (
      <div className='cz-container'>
        <div className="page-header-row-centered">
          <h3>Run History — {selectedConfig.instance_name} / {selectedConfig.schema_name}</h3>
          <div className="page-header-actions">
            <Tooltip title={selectedConfig.is_active ? 'Run Now' : 'Monitor is inactive — activate it to run'}>
              <span>
                <Button
                  label="Run Now"
                  className="btn btn-action"
                  onClick={() => onRunNow(selectedConfig.config_id)}
                  disabled={isRunning || !selectedConfig.is_active}
                />
              </span>
            </Tooltip>
          </div>
        </div>
        
        {isLoadingResults && <LinearProgress />}
        
        {results.length === 0 && !isLoadingResults ? (
          <EmptyState message="No run history yet." />
        ) : (
          <Table className='data-table clickable'>
            <TableHead>
              <TableRow>
                <TableCell>Started At</TableCell>
                <TableCell>Completed At</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Total Changes</TableCell>
                <TableCell>Objects Added</TableCell>
                <TableCell>Objects Removed</TableCell>
                <TableCell>Objects Modified</TableCell>
                <TableCell>Columns Changed</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.map((result) => (
                <TableRow key={result.result_id} hover>
                  <TableCell 
                    style={{ cursor: 'pointer', color: '#1976d2' }}
                    onClick={() => result.total_changes > 0 && onViewChanges(result)}
                  >
                    {result.run_started_at ? new Date(result.run_started_at).toLocaleString() : '—'}
                  </TableCell>
                  <TableCell>{result.run_completed_at ? new Date(result.run_completed_at).toLocaleString() : '—'}</TableCell>
                  <TableCell>{this.renderStatusChip(result.status)}</TableCell>
                  <TableCell>
                    <span style={{ fontWeight: result.total_changes > 0 ? 'bold' : 'normal', color: result.total_changes > 0 ? '#f44336' : '#666' }}>
                      {result.total_changes}
                    </span>
                  </TableCell>
                  <TableCell style={{ color: '#4caf50' }}>{result.objects_added || 0}</TableCell>
                  <TableCell style={{ color: '#f44336' }}>{result.objects_removed || 0}</TableCell>
                  <TableCell style={{ color: '#ff9800' }}>{result.objects_modified || 0}</TableCell>
                  <TableCell>{(result.columns_added || 0) + (result.columns_removed || 0) + (result.columns_modified || 0)}</TableCell>
                  <TableCell>
                    <div className='actions-menu'>
                      <IconButton onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget, menuOpenId: result.result_id })}>
                        <i className='material-icons'>more_horiz</i>
                      </IconButton>
                      <Menu 
                        anchorEl={this.state.menuAnchorEl} 
                        open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === result.result_id} 
                        onClose={() => this.setState({ menuAnchorEl: null, menuOpenId: null })}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        transformOrigin={{horizontal: 'right', vertical: 'top'}}
                      >
                        {result.total_changes > 0 && (
                          <MenuItemMUI
                            className='wl-group-card-menu'
                            onClick={() => onViewChanges(result)}
                          >View Changes</MenuItemMUI>
                        )}
                        {result.error_message && (
                          <MenuItemMUI
                            className='wl-group-card-menu'
                            disabled
                          >{`Error: ${result.error_message}`}</MenuItemMUI>
                        )}
                      </Menu>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    );
  }
}

export default SchemaMonitorResults;
